module.exports = __webpack_public_path__ + "img/2024-12-12b_1.139370ca.jpg";